import type { risorse as it } from "../it/risorse.ts";

/** La scheda Risorse: grafici, live, log della finestra e avvisi dello stack. */
export const risorse: typeof it = {
  "risorse.graficoCpu": "CPU %",
  "risorse.graficoMemoria": "Memory (% of limit)",
  "risorse.graficoRete": "Network (KB/s)",
  "risorse.rapida.1h": "1h",
  "risorse.rapida.6h": "6h",
  "risorse.rapida.24h": "24h",
  "risorse.rapida.7g": "7d",
  "risorse.liveAiuto": "One sample every 2 seconds, for up to 5 minutes",
  "risorse.inizio": "Time window start",
  "risorse.fine": "Time window end",
  "risorse.liveTerminato": "Live ended.",
  "risorse.attesaDati": "Waiting for the first data…",
  "risorse.nessunDato": "No data in this time window",
  "risorse.servonoContainer": "The stack needs running containers.",
  "risorse.ogni15": "Usage is recorded every 15 seconds while the stack is running.",
  "risorse.graficiAiuto":
    "Drag across a chart to narrow the time window; click a line or a row to follow a service.",
  "risorse.servizio": "Service",
  "risorse.cpuOra": "CPU now",
  "risorse.cpuPicco": "CPU peak",
  "risorse.memOra": "Mem now",
  "risorse.memPicco": "Mem peak",
  "risorse.reteOra": "Net now",
  "risorse.retePicco": "Net peak",
  "risorse.eventi": "Events",
  "risorse.nessunLog": "No log lines in this time window.",
  "risorse.sogliaCpu": "CPU %",
  "risorse.perMinuti": "for minutes",
  "risorse.sogliaMemoria": "Memory %",
  "risorse.avvisi": "Alerts for this stack",
  "risorse.inviaAvvisi": "Send alerts for this stack",
  "risorse.campoVuoto": "An empty field uses the global threshold from Settings.",
};
